import React, { useState } from "react"
import { Container, Row, Col } from "reactstrap"
import TaskList from "../../TaskManagement/TaskList"
import TaskManagementListHeader from "../../TaskManagement/TaskManagementListHeader"
import { usePresetFilters, combineFilters } from "../../Filters/presetFilters"
import { TASK_TAB_PRESETS } from "../../TaskManagement/taskFilterPresets"
import { useAdvancedFilters } from "../../Filters/filterUrl"
import "./TasksTab.css"


const TasksTab = ({ incidentId }) => {
    const [orderBy, setOrderBy] = useState(['-date_added'])
    const [filterValues, setFilterValues] = useState({ searchTerm: '', incidentId: incidentId })
    const boardId = process.env.REACT_APP_INCIDENT_BOARD_ID
    // TASK_TAB_PRESETS is used directly rather than getTaskFilterPresets(boardId):
    // boardId comes from REACT_APP_INCIDENT_BOARD_ID, which is undefined in tests
    // and would silently fall back to getTaskFilterPresets(undefined, undefined),
    // My Tasks' branch. That yields a for_user preset with filterValues: null
    // (no currentUserId to fill it in here), which the backend rejects --
    // first_value raises on a null value -- erroring the whole query.
    //
    // It is also not BOARD_PRESETS: this tab lists every task on one incident,
    // so it takes the "hide archived" default but not the status one.
    const [presets, setPresets] = usePresetFilters(TASK_TAB_PRESETS)
    const [advancedFilters] = useAdvancedFilters()
    const filters = combineFilters(presets, advancedFilters)

    return (
        <div>
            <div className="incident-overview-header">
                <div className="incident-overview-header__titles">
                    <h3 className="incident-overview-header__title">Tasks</h3>
                    <p className="incident-overview-header__subtitle">Track and manage all tasks associated with this incident.</p>
                </div>
            </div>
            <Container fluid>
                <TaskManagementListHeader
                    parentBoardId={boardId}
                    filterValues={filterValues}
                    setFilterValues={(res) => setFilterValues({ ...res })}
                    incidentId={incidentId}
                    presets={presets}
                    onPresetsChange={setPresets}
                />
            </Container>
            <Row>
                <Col className="TaskListColumn">
                    <TaskList {...filterValues} orderBy={orderBy} filters={filters} />
                </Col>
            </Row>
        </div>
    )
}

export default TasksTab
